import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategorizedSelector = _resolveComponent("CategorizedSelector")!

  return (_openBlock(), _createBlock(_component_CategorizedSelector, {
    categories: _ctx.courierShuttleCategories,
    disabled: _ctx.disabled,
    "has-more-data": _ctx.hasMoreData,
    "is-loading-data": _ctx.isLoadingData,
    "on-load-data": _ctx.loadCourierShuttleData,
    "on-load-more": _ctx.loadMoreData,
    "on-reset-data": _ctx.resetData,
    "on-search": _ctx.handleSearch,
    "minimum-search-char": 3,
    "header-text": _ctx.headerText,
    placeholder: _ctx.placeholder,
    "search-placeholder": _ctx.searchPlaceholder,
    onChange: _ctx.handleCourierShuttleChange,
    modelValue: _ctx.internalSelectedItem,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.internalSelectedItem = $event)),
    showTab: !_ctx.isHideTab
  }, null, 8, ["categories", "disabled", "has-more-data", "is-loading-data", "on-load-data", "on-load-more", "on-reset-data", "on-search", "header-text", "placeholder", "search-placeholder", "onChange", "modelValue", "showTab"]))
}